var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { uploadLink } from '@/apollo/middlewares/uploadLinkMiddleware';
import { history, persistor, store } from '@/store/store';
import { Provider } from 'react-redux';
import { HistoryRouter } from 'redux-first-history/rr6';
import { PersistGate } from 'redux-persist/integration/react';
import { ApolloAuthProvider } from '@agentguru/auth';
import { CheckAppVersionProvider } from '@agentguru/components';
import { apolloCache } from './apollo';
import { AppBottomNavBarProvider } from './ui/layouts/AppBottomNavBar';
export function AppProviders(_a) {
    var children = _a.children;
    return (_jsx(Provider, __assign({ store: store }, { children: _jsx(HistoryRouter, __assign({ history: history }, { children: _jsx(PersistGate, __assign({ persistor: persistor }, { children: _jsx(ApolloAuthProvider, __assign({ link: [uploadLink], cache: apolloCache }, { children: _jsx(CheckAppVersionProvider, { children: _jsx(AppBottomNavBarProvider, { children: children }) }) })) })) })) })));
}
